module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.9882/images/animated-images/cmsfree-dnd-editor.webm"